<script>
/* eslint-disable */
import GeneralInformation from "../components/pages/recipe/GeneralInformation.vue";
import Ingredients from "../components/pages/recipe/Ingredients.vue";
import CreateUpdateIngredient from "../components/pages/recipe/ingredients/CreateUpdateIngredient.vue";
export default {
  name: "Tabs",
  components: {
    GeneralInformation,
    Ingredients,
    CreateUpdateIngredient,
  },
  data() {
    return {
      tabIndex: 0,
      id: this.$route.params.id ? this.$route.params.id : null,
    };
  },
  watch: {
    tabIndex(val) {},
  },
  mounted() {
    this.$store.dispatch("recipes/getUnits");
    this.$store.dispatch("recipes/getIngredients");
    // this.$store.dispatch("recipes/getUsers");
    this.$store.commit(`recipes/setEmptyRecipe`);
  },
};
</script>

<template>
  <b-card no-body class="data-listing-tabs">
    <b-tabs card v-model="tabIndex">
      <b-tab title="General Information" active ref="startTab">
        <general-information> </general-information>
      </b-tab>
      <b-tab title="Ingredients/Instruction" :disabled="true">
        <ingredients> </ingredients>
      </b-tab>
    </b-tabs>
    <create-update-ingredient></create-update-ingredient>
  </b-card>
</template>